import { memo } from 'react';

import AvatarCircle from '../AvatarCircle';
import { OButton, OModal } from '@src/shared';
import BackgroundEffectsTabs from '../BackgroundEffectsTabs';
import { AdvancedSettings } from './AdvancedSettings';

import useBackgroundEffectsModal from '@src/hooks/useBackgroundEffectsModal';
import { useVirtualBackgroundPreview } from '@src/hooks/virtualBackground/useVirtualBackgroundPreview';

import './BackgroundEffectsModal.scss';

const BackgroundEffectsModal = () => {
  const {
    currentPeer,
    isCamClosed,
    isApplyButtonDisabled,
    isBackgroundEffectsOpen,
    selectedBackgroundEffect,
    handleSaveSelectedBackground,
    removeBackgroundEffect,
    onSelectBackgroundEffect,
    handleCloseModal,
    isPreviewEffectEnabled,
  } = useBackgroundEffectsModal();

  const { setVideoRef } = useVirtualBackgroundPreview({
    enabled: isPreviewEffectEnabled,
  });

  return (
    <OModal
      isOpen={isBackgroundEffectsOpen}
      classes={{
        container: 'background-effects-layout-modal',
        closeIcon: 'close-icon',
      }}
      title="Virtual background"
      onClose={handleCloseModal}
    >
      <div className="container-layout">
        <div className="main-section">
          <p className="preview-title">Preview</p>
          {!isCamClosed ? (
            <div className="preview-section d-flex">
              <video className="mirror" ref={setVideoRef} autoPlay muted playsInline />
              {selectedBackgroundEffect.value && (
                <button className="remove-background-btn" onClick={removeBackgroundEffect}>
                  Remove background
                </button>
              )}
            </div>
          ) : (
            <div className="avatar-container d-flex">
              <AvatarCircle peerId={currentPeer?.peer_info?.peer_id || ''} avatarImgSize={235} />
            </div>
          )}
        </div>

        <div className="backgrounds-section-container">
          <BackgroundEffectsTabs onSelectBackgroundEffect={onSelectBackgroundEffect} />
        </div>
      </div>

      {/* Advanced Settings */}
      {process.env.REACT_APP_ENV !== 'production' && <AdvancedSettings />}
      <OButton
        variant="success"
        size="large"
        text="Apply"
        isDisabled={isApplyButtonDisabled}
        onClick={handleSaveSelectedBackground}
      />
    </OModal>
  );
};
export default memo(BackgroundEffectsModal);
